import { useState } from "react";
import { LANG_NAMES, LANGS, useI18n, type Lang, type LangPref } from "../lib/i18n";
import { Sheet } from "./ui";

/** A language as its flag (a picture, so it shows on Windows too, where flag emoji don't). */
export function Flag({ lang, size = 22 }: { lang: Lang; size?: number }) {
  return <img className="flag" src={`/flags/${lang}.svg`} alt="" width={Math.round(size * 1.33)} height={size} />;
}

/**
 * The language button: the current flag and name; tapping it opens every language as a flag tile.
 * `auto` adds "this phone's language" as the first choice.
 */
export function LangPicker({ value, onChange, auto, compact }: { value: LangPref; onChange: (v: LangPref) => void; auto?: boolean; compact?: boolean }) {
  const { t, lang } = useI18n();
  const [open, setOpen] = useState(false);
  const shown: Lang = value === "auto" ? lang : value;
  const pick = (v: LangPref) => {
    setOpen(false);
    onChange(v);
  };
  return (
    <>
      <button type="button" className={`lang-btn${compact ? " compact" : ""}`} onClick={() => setOpen(true)} aria-label={t("account.language")}>
        <Flag lang={shown} size={compact ? 16 : 18} />
        {!compact && <span>{value === "auto" ? t("account.languageAuto") : LANG_NAMES[shown]}</span>}
        <span aria-hidden="true" className="lang-caret">⌄</span>
      </button>
      <Sheet open={open} onClose={() => setOpen(false)} title={t("account.language")}>
        <div className="lang-grid">
          {auto && (
            <button type="button" className="lang-tile" aria-pressed={value === "auto"} onClick={() => pick("auto")}>
              <span className="lang-auto" aria-hidden="true">📱</span>
              <span>{t("account.languageAuto")}</span>
            </button>
          )}
          {LANGS.map((l) => (
            <button key={l} type="button" className="lang-tile" aria-pressed={value === l} onClick={() => pick(l)}>
              <Flag lang={l} size={30} />
              <span>{LANG_NAMES[l]}</span>
            </button>
          ))}
        </div>
      </Sheet>
    </>
  );
}
